module.exports = __webpack_public_path__ + "static/media/more_horiz-24px.95c5c11c.svg";